export default __webpack_public_path__ + "static/media/Logo-sidebar.4e500eca.svg";